const USERS = "users"; //users collection in Firestore
const TIME = 30; //seconds

// PRODUCTION VARIABLES
const QUESTIONS = "questions"; //questions collection in Firestore
const QUESTIONSIDS = "questionsIDs"; //questionsIDs collection in Firestore
const QUESTIONSIDS_DOCID = "D5lrnjJzMmgtQb9Rs7WI"; //doc id of the only document in questionsIDs collection

// TEST VARIABLES
// const QUESTIONS = "questions_test"; //questions_test collection in Firestore
// const QUESTIONSIDS = "questionsIDs_test"; //questionsIDs_test collection in Firestore
// const QUESTIONSIDS_DOCID = "Z22vi3NUdK9c24LYww5X"; //doc id of the only document in questionsIDs_test collection

export { QUESTIONS, QUESTIONSIDS, QUESTIONSIDS_DOCID, USERS, TIME };
